
import React, { useState } from 'react';
import { Row, Col, Card, CardTitle, CardSubtitle, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import TextField from '../../../../components/TextField';

//Api
import usuario_api from '../../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//context
import { useAuth } from '../../../../context/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

export default function EsqueceuSenhaRestrito({ btnVoltar }) {
    const navigate = useNavigate();
    const { setLoading } = useAuth();

    //Estado de controle do valor do email
    const [email, setEmail] = useState("");

    //Função de onChange dos campos da tela inicial
    const onChange = (e) => {
        const { value } = e.target;
        setEmail(value)
    }

    //Função de envio dos dados 
    const onSubmit = () => {
        setLoading(true);
        usuario_api.esqueceuSenhaRestrito(email).then(response => {
            showMessage("Sucesso", "E-mail de recuperação enviado com sucesso!", "success", btnVoltar);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    return (
        <div className='mainContainerLogin'>
            <div style={{ marginTop: "10vh" }} className='w-75 d-flex align-items-center justify-content-start mb-4'>
                <Button onClick={btnVoltar}>
                    <FontAwesomeIcon icon={faAngleLeft} />  Voltar
                </Button>
            </div>
            <Card className='w-75' style={{ border: "none", padding: "1rem" }}>
                <Row className='p-4'>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center' style={{ borderRight: "1px solid #ccc" }}>
                        <div className="mb-3">
                            <img src={require('../../../../assets/img/logo.png')} className='img-logo' alt="logo do sistema GAIA" />
                        </div>
                        <CardTitle tag={'h4'} style={{ color: "#666" }} className='mb-2 font-weight-normal'>Seja bem vindo ao GAIA </CardTitle>
                        <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '16pt' }} className='mb-2'>
                            Sistema de Gestão Arbórea
                        </CardSubtitle>
                        <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '14pt' }} className='mb-4  d-flex align-items-center justify-content-center fw-bold text-warning'>
                            Área Restrita
                        </CardSubtitle>
                    </Col>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-around '>
                        <CardTitle tag={'h4'} className=' text-center' style={{ color: "#666" }}>E-mail para recuperação</CardTitle>
                        <TextField label={"E-mail"} onChange={onChange} value={email} name={"email"} />
                        <div>
                            <Button color='success' style={{ width: "80%" }} onClick={onSubmit}>
                                Entrar
                            </Button>
                        </div>
                    </Col>

                </Row>
            </Card>
        </div>
    )
}